module.exports = __webpack_public_path__ + "static/img/industry1.96ec67a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industry1.png
// module id = WX/U
// module chunks = 2